var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRearParkingCamera24 = function SvgRearParkingCamera24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.961V6.526c0-1.2.486-2.352 1.35-3.2A4.652 4.652 0 0 1 7.609 2h8.782c1.223 0 2.395.477 3.26 1.326.863.848 1.349 2 1.349 3.2v9.948c0 1.2-.486 2.352-1.35 3.2A4.652 4.652 0 0 1 16.391 21H11m-4 2H5.631a4.563 4.563 0 0 1-3.275-1.397A4.845 4.845 0 0 1 1 18.229V17m6 3h-.684a2.28 2.28 0 0 1-1.632-.695A2.44 2.44 0 0 1 4 17.619V17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.152 9H8.848C7.828 9 7 9.739 7 10.65v1.7c0 .911.827 1.65 1.848 1.65h3.304c1.02 0 1.848-.739 1.848-1.65v-1.7C14 9.739 13.173 9 12.152 9Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14 10.31 1.913-1.206A.651.651 0 0 1 16.28 9a.659.659 0 0 1 .362.122c.11.076.2.185.263.315a.98.98 0 0 1 .096.427v3.272a.983.983 0 0 1-.09.414.826.826 0 0 1-.249.312.645.645 0 0 1-.704.06L14 12.878",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgRearParkingCamera24;